import React from 'react';
import { Table, Form  } from 'react-bootstrap';
import { useState, useEffect } from 'react';
import Select from 'react-select';
import { postRequestOptions, getRequestOptions} from "../helpers/Fetchwrapper";
import { Card } from 'react-bootstrap-v5';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

// Define a type for the sales data
interface SalesData {
    userName: string;
    srTotalSales: number;
    months: {
        [month: string]: {
            items: {
                productName: string;
                packing: string;
                size: number;
                productUnitName: string;
                itemUnitName: string;
                deliveredQuantity: number;
                deliveredAmount: number;
                remarks: string;
            }[];
            totalSales: number;
        };
    };
};

interface SalespersonWiseSalesProps {

}

const MonthlyProductionReport: React.FC<SalespersonWiseSalesProps> = (props) => {

    const [loading, setLoading] = useState(false);
    const [salesData, setSalesData] = useState<SalesData[]>([]);
    const [formData, setFormData] = useState({
        idProjects: '',
        fromDate: '',
        toDate: '',
    });

    const [projects, setProjects] = useState([]);
	const [project, setProject] = useState({ label: 'Select Project', value: '' });

    useEffect(() => {
        getProjects();
    }, [])

     useEffect(() => {
        if(projects.length>0){
            setProject(projects[0]);
            setFormData({
                ...formData,
                idProjects: projects[0].value,
            });
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [projects])

    const getProjects = () => {
		fetch(
			process.env.REACT_APP_API_URL + 'lead/projects',
			getRequestOptions()
		)
			.then((resp) => {
				return resp.json()
			})
			.then((resp) => {
				let projectObj = resp.data.map((item: any) => {
					item.label = item.name;
					item.value = item.id;
					return item
				})
				setProjects(projectObj);
			})
			.catch((error) => {
				console.log(error, 'catch the hoop')
			})
	}

    const handleProjectChange = (project: any) => {
		setProject(project);
        if(project){
            setFormData({ ...formData, idProjects: project.value });
        }else{
		    setFormData({ ...formData, idProjects: '' });
        }
	}  

    const formatMonthYear = (input: string) => {
        const [year, month] = input.split('-');
        const date = new Date(parseInt(year), parseInt(month) - 1); // JS months are 0-based
        const monthName = date.toLocaleString('default', { month: 'long' });
        return `${year} ${monthName}`;
    }

    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const { name, value } = event.target;
        let newVal;
        if(name === 'fromDate'){
            newVal = value+'-01'
        }else{
            newVal = getFullDate(value)
        }
        setFormData({ ...formData, [name]: newVal });
    };

    const getFullDate = (value: string) => {
        const [year, month] = value.split('-').map(Number);
        // Create a date for the first day of the next month, then subtract one day
        const lastDate = new Date(year, month, 0);
        // Format to YYYY-MM-DD
        const fullDate = lastDate.toISOString().slice(0, 10);
        return fullDate;
    };

    const handleViewReport = async () => {
        setLoading(true);
        try {
            const response = await fetch(process.env.REACT_APP_API_URL + 'reports/monthly-production-report', postRequestOptions(formData));
            const data = await response.json();
           
            if (data.success) {
                setSalesData(data.data.productions);
            } else {
                setSalesData([]);
                for (const i in data.errors) {
                    toast(<strong>{data.errors[i].join(' ')}</strong>, { type: 'error', position: 'bottom-right', autoClose: 4000 });
                }
            }
        } catch (error) {
            console.error('Error submitting data:', error);
        } finally {
            setLoading(false);
        }
    };

    const queryParams = new URLSearchParams(formData);

    return (
        <>
            <Card className='mb-4'>
                <Card.Body>
                    <Card.Title></Card.Title>
                    <Card.Text>
                        <div className='row'>
                            <div className='col-md-2'>
                                <Form.Group className="mb-3" controlId="project">
                                    <Form.Label>Project<span className='required'></span></Form.Label>
                                    <Select
                                        value={project}
                                        onChange={handleProjectChange}
                                        options={projects}
                                        menuPosition="fixed"
                                        styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                                        isClearable={true}
                                    />
                                </Form.Group>
                            </div>
                           
                            <div className='col-md-2'>
                                <Form.Group className="mb-3" controlId="fromDate">
                                    <Form.Label>From Month<span className='required'></span></Form.Label>
                                    <Form.Control type="month" placeholder="From Month" name='fromDate' onChange={handleChange}/>
                                </Form.Group>
                            </div>
                            <div className='col-md-2'>
                                <Form.Group className="mb-3" controlId="toDate">
                                    <Form.Label>To Month<span className='required'></span></Form.Label>
                                    <Form.Control type="month" placeholder="To Month" name='toDate' onChange={handleChange}/>
                                </Form.Group>
                            </div>
                            <div className='col-md-3'>
                                <div className="form-control-sm ps-0 mt-7">
                                    <button className='btn btn-sm btn-primary p-3' onClick={handleViewReport} disabled={loading}>
                                        {loading && (
                                            <span className="spinner-border spinner-border-sm"></span>
                                        )}
                                        <span><i className='fas fa-eye'></i>View Report</span>
                                    </button>
                                    <a className="btn btn-sm btn-primary p-3 ms-3" href={`${process.env.REACT_APP_BACKEND}monthly_production_report_download?` + queryParams.toString()}><i className='fas fa-download'></i>Excel Download</a>
                                    {/* <a className="btn btn-sm btn-primary p-3 ms-3" href={`${process.env.REACT_APP_BACKEND}monthly_production_report_print?` + queryParams.toString()}><i className='fas fa-print'></i>Print</a> */}
                                </div>                                
                            </div>
                        </div>
                    </Card.Text>
                </Card.Body>
            </Card>            

            <div className='row'>
                <div className='col-12'>
                    
                    <Table responsive striped bordered hover>
                        <thead>
                            <tr>
                                <th>Month</th>
                                <th>Product</th>
                                <th>Packing</th>
                                <th>Qty</th>
                                <th>Unit</th>
                            </tr>
                        </thead>
                        <tbody>
                            {Object.entries(salesData).map(([month, products]) =>
                            products.map((product, index) => (
                                <tr key={`${month}-${product.id_products}-${index}`}>
                                {index === 0 &&
                                <td rowSpan={products.length}>{formatMonthYear(month)}</td>
    }
                                <td>{product.product_name} <span className='text-muted'>{product.alternate_name}</span></td>
                                <td>{product.packing+' '+product.item_unit_name}</td>
                                <td>{product.quantity}</td>
                                <td>{product.unit_name}</td>
                                </tr>
                            ))
                            )}
                        </tbody>
                    </Table>

                </div>

            </div>
            
        </>
    );
};

export default MonthlyProductionReport;